import SearchIcon from '@mui/icons-material/SearchTwoTone';
import { IconButton, TextField, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReloadIcon from '../../components/icons/ReloadIcon';

interface BookingSearchInputProps {
    currentBookingId?: string;
    onSearch: (bookingId: string) => void;
    onRefresh: () => void;
}

const BookingSearchInput = (props: BookingSearchInputProps) => {

    const { t } = useTranslation();
    const [value, setValue] = useState<string>('');

    useEffect(() => {
        if (props.currentBookingId) {
            setValue(props.currentBookingId);
        }
    }, [props.currentBookingId]);

    const isSameBookingId = props.currentBookingId === value;

    const triggerSearch = () => {
        props.onSearch(value);
    };

    return (
        <div className={'flex items-center'}>
            <TextField
                size={'medium'}
                variant={'outlined'}
                className={'flex flex-grow'}
                placeholder={t('bookings.search_booking')}
                value={value}
                onChange={event => setValue(event.target.value)}
                onKeyUp={event => event.keyCode === 13 && triggerSearch()}
                InputProps={{
                    className: 'text-foreground border-foreground border',
                }}
            />
            {isSameBookingId ? (
                <Tooltip title={'Buchung neu laden'}>
                    <IconButton className={'text-foreground -mr-2'} onClick={props.onRefresh} size={'large'}>
                        <ReloadIcon />
                    </IconButton>
                </Tooltip>
            ) : (
                <Tooltip title={'Buchung suchen'}>
                    <IconButton className={'text-foreground'} onClick={triggerSearch} size={'large'}>
                        <SearchIcon />
                    </IconButton>
                </Tooltip>
            )}
        </div>
    );
};

export default BookingSearchInput;
